// Only users created on/after this date are eligible for Quick Start
export const quickStartEligibleFromDate = new Date('2026-08-25T00:00:00Z')
